// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"793":"a3065cab621ead229d45212f93cf814b","929":"4db150d8b8ef8df95a0b20bd24174606"}[chunkId] + ".js";
};